import { createTrackedUrl } from './tracking.js';

/** Configure native links before they can be activated or opened from a context menu. */
export function updateNavigationLink(link, action, currentProductId) {
  link.href = createTrackedUrl(action, currentProductId);
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
}

/** Primary clicks and middle-clicks activate links; other controls use primary clicks. */
export function isControlActivation(event, control) {
  return (event.type === 'click' && event.button === 0)
    || (event.type === 'auxclick' && event.button === 1 && control.localName === 'a');
}
